import debounce from 'lodash/debounce';
import { useEffect, useMemo, useRef } from 'react';

export default function useDebouncedCallback(callback: (...args: any[]) => void, delay: number) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return useMemo(() => {
    return debounce((...args: any[]) => {
      callbackRef.current(...args);
    }, delay);
  }, [delay]);
}
